<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-menu-facturas',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isShowIdFacturaInReceivedSearch',
      'isShowCompradorFacturaInReceivedSearch',
      'isShowNumeroFacturaInReceivedSearch',
      'isShowEmisionFacturaInReceivedSearch',
      'isShowFechaRegistroFacturaInReceivedSearch',
      'isShowClaseFacturaInReceivedSearch',
      'isShowImporteFacturaInReceivedSearch',
      'isShowEstadoFacturaInReceivedSearch',
      'isShowVendedorFacturaInReceivedSearch',
      'isShowDivisaFacturaInReceivedSearch',
      'isShowCentroVendedorFacturaInReceivedSearch',
      'isShowCentroGenericCompradorFacturaInReceivedSearch',
      'isShowCentroCompradorFacturaInReceivedSearch',
      'isShowCentroEntregaCompradorFacturaInReceivedSearch',
      'isShowCentroFacturadoCompradorFacturaInReceivedSearch',
      'isShowServicioFacturaInReceivedSearch',
      'isShowReceptionMethodInReceivedSearch',
      'isShowNumRegistroFacturaInReceivedSearch',
      'isShowNumSerieFacturaInReceivedSearch',
      'isShowIdDatabaseFacturaInReceivedSearch',
      'isShowAccountingDateInReceivedSearch',
      'isShowPaymentDateInReceivedSearch',
      'isShowPaymentMethodInReceivedSearch',
      'isShowClientInvoiceNumberInReceivedSearch',
      'isShowSentInReceivedSearch',
      'optionsFilterService',
      'canViewDistributionCentres'
    ])
  },

  methods: {
    ...mapActions([
      'isShowIdFacturaInReceivedSearchAction',
      'isShowCompradorFacturaInReceivedSearchAction',
      'isShowNumeroFacturaInReceivedSearchAction',
      'isShowEmisionFacturaInReceivedSearchAction',
      'isShowFechaRegistroFacturaInReceivedSearchAction',
      'isShowClaseFacturaInReceivedSearchAction',
      'isShowImporteFacturaInReceivedSearchAction',
      'isShowEstadoFacturaInReceivedSearchAction',
      'isShowVendedorFacturaInReceivedSearchAction',
      'isShowDivisaFacturaInReceivedSearchAction',
      'isShowCentroVendedorFacturaInReceivedSearchAction',
      'isShowNumRegistroFacturaInReceivedSearchAction',
      'isShowNumSerieFacturaInReceivedSearchAction',
      'isShowCentroGenericCompradorFacturaInReceivedSearchAction',
      'isShowCentroCompradorFacturaInReceivedSearchAction',
      'isShowCentroEntregaCompradorFacturaInReceivedSearchAction',
      'isShowCentroFacturadoCompradorFacturaInReceivedSearchAction',
      'isShowServicioFacturaInReceivedSearchAction',
      'isShowReceptionMethodInReceivedSearchAction',
      'isShowIdDatabaseFacturaInReceivedSearchAction',
      'isShowAccountingDateInReceivedSearchAction',
      'isShowPaymentDateInReceivedSearchAction',
      'isShowPaymentMethodInReceivedSearchAction',
      'isShowClientInvoiceNumberInReceivedSearchAction',
      'isShowSentInReceivedSearchAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        // case 'id':
        //   this.$store.dispatch('isShowIdFactura', !this.isShowIdFactura)
        //   break;
        case 'comprador':
          isShow = !this.isShowCompradorFacturaInReceivedSearch
          this.isShowCompradorFacturaInReceivedSearchAction(isShow)
          break
        case 'numero':
          isShow = !this.isShowNumeroFacturaInReceivedSearch
          this.isShowNumeroFacturaInReceivedSearchAction(isShow)
          break
        case 'emision':
          isShow = !this.isShowEmisionFacturaInReceivedSearch
          this.isShowEmisionFacturaInReceivedSearchAction(isShow)
          break
        case 'fecha-registro':
          isShow = !this.isShowFechaRegistroFacturaInReceivedSearch
          this.isShowFechaRegistroFacturaInReceivedSearchAction(isShow)
          break
        case 'clase-factura':
          isShow = !this.isShowClaseFacturaInReceivedSearch
          this.isShowClaseFacturaInReceivedSearchAction(isShow)
          break
        case 'importe':
          isShow = !this.isShowImporteFacturaInReceivedSearch
          this.isShowImporteFacturaInReceivedSearchAction(isShow)
          break
        case 'estado':
          isShow = !this.isShowEstadoFacturaInReceivedSearch
          this.isShowEstadoFacturaInReceivedSearchAction(isShow)
          break
        case 'recepcion':
          isShow = !this.isShowReceptionMethodInReceivedSearch
          this.isShowReceptionMethodInReceivedSearchAction(isShow)
          break
        case 'vendedor':
          isShow = !this.isShowVendedorFacturaInReceivedSearch
          this.isShowVendedorFacturaInReceivedSearchAction(isShow)
          break
        case 'divisa':
          isShow = !this.isShowDivisaFacturaInReceivedSearch
          this.isShowDivisaFacturaInReceivedSearchAction(isShow)
          break
        case 'centro-vendedor':
          isShow = !this.isShowCentroVendedorFacturaInReceivedSearch
          this.isShowCentroVendedorFacturaInReceivedSearchAction(isShow)
          break
        case 'centro':
          isShow = !this.isShowCentroGenericCompradorFacturaInReceivedSearch
          this.isShowCentroGenericCompradorFacturaInReceivedSearchAction(isShow)
          break
        case 'centro-comprador':
          isShow = !this.isShowCentroCompradorFacturaInReceivedSearch
          this.isShowCentroCompradorFacturaInReceivedSearchAction(isShow)
          break
        case 'centro-entrega':
          isShow = !this.isShowCentroEntregaCompradorFacturaInReceivedSearch
          this.isShowCentroEntregaCompradorFacturaInReceivedSearchAction(isShow)
          break
        case 'centro-facturado':
          isShow = !this.isShowCentroFacturadoCompradorFacturaInReceivedSearch
          this.isShowCentroFacturadoCompradorFacturaInReceivedSearchAction(isShow)
          break
        case 'servicio':
          isShow = !this.isShowServicioFacturaInReceivedSearch
          this.isShowServicioFacturaInReceivedSearchAction(isShow)
          break
        case 'numero-registro':
          isShow = !this.isShowNumRegistroFacturaInReceivedSearch
          this.isShowNumRegistroFacturaInReceivedSearchAction(isShow)
          break
        case 'numero-serie':
          isShow = !this.isShowNumSerieFacturaInReceivedSearch
          this.isShowNumSerieFacturaInReceivedSearchAction(isShow)
          break
        case 'id':
          isShow = !this.isShowIdDatabaseFacturaInReceivedSearch
          this.isShowIdDatabaseFacturaInReceivedSearchAction(isShow)
          break
        case 'accountingDate':
          isShow = !this.isShowAccountingDateInReceivedSearch
          this.isShowAccountingDateInReceivedSearchAction(isShow)
          break
        case 'paymentDate':
          isShow = !this.isShowPaymentDateInReceivedSearch
          this.isShowPaymentDateInReceivedSearchAction(isShow)
          break
        case 'paymentMethod':
          isShow = !this.isShowPaymentMethodInReceivedSearch
          this.isShowPaymentMethodInReceivedSearchAction(isShow)
          break
        case 'clientInvoiceNumber':
          isShow = !this.isShowClientInvoiceNumberInReceivedSearch
          this.isShowClientInvoiceNumberInReceivedSearchAction(isShow)
          break
        case 'sent':
          isShow = !this.isShowSentInReceivedSearch
          this.isShowSentInReceivedSearchAction(isShow)
          break
        default:
          break
      }
      this.$forceUpdate()
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      if (this.canViewDistributionCentres) {
        this.columns = [
          {
            text: this.$t('invoices.tooltip.sent'), value: 'sent', show: this.isShowSentInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer'), value: 'comprador', show: this.isShowCompradorFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_generic_centre'), value: 'centro', show: this.isShowCentroGenericCompradorFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_centre'), value: 'centro-comprador', show: this.isShowCentroCompradorFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_delivery_centre'), value: 'centro-entrega', show: this.isShowCentroEntregaCompradorFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_invoicee_centre'), value: 'centro-facturado', show: this.isShowCentroFacturadoCompradorFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.seller'), value: 'vendedor', show: this.isShowVendedorFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.seller_centre'), value: 'centro-vendedor', show: this.isShowCentroVendedorFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.series_code'), value: 'numero-serie', show: this.isShowNumSerieFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.invoice_number'), value: 'numero', show: this.isShowNumeroFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.issue_date'), value: 'emision', show: this.isShowEmisionFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.creation_date'), value: 'fecha-registro', show: this.isShowFechaRegistroFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.invoice_class'), value: 'clase-factura', show: this.isShowClaseFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.amount'), value: 'importe', show: this.isShowImporteFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.status'), value: 'estado', show: this.isShowEstadoFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.reception_method'), value: 'recepcion', show: this.isShowReceptionMethodInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.register_number'), value: 'numero-registro', show: this.isShowNumRegistroFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.currency'), value: 'divisa', show: this.isShowDivisaFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.project'), value: 'servicio', show: this.isShowServicioFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.id_invoice'), value: 'id', show: this.isShowIdDatabaseFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.paymentMethod'), value: 'paymentMethod', show: this.isShowPaymentMethodInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.clientInvoiceNumber'), value: 'clientInvoiceNumber', show: this.isShowClientInvoiceNumberInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.accountingDate'), value: 'accountingDate', show: this.isShowAccountingDateInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.paymentDate'), value: 'paymentDate', show: this.isShowPaymentDateInReceivedSearch
          }
        ]
      } else {
        this.columns = [
          {
            text: this.$t('invoices.tooltip.sent'), value: 'sent', show: this.isShowSentInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer'), value: 'comprador', show: this.isShowCompradorFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_generic_centre'), value: 'centro', show: this.isShowCentroGenericCompradorFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.seller'), value: 'vendedor', show: this.isShowVendedorFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.seller_centre'), value: 'centro-vendedor', show: this.isShowCentroVendedorFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.series_code'), value: 'numero-serie', show: this.isShowNumSerieFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.invoice_number'), value: 'numero', show: this.isShowNumeroFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.issue_date'), value: 'emision', show: this.isShowEmisionFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.creation_date'), value: 'fecha-registro', show: this.isShowFechaRegistroFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.invoice_class'), value: 'clase-factura', show: this.isShowClaseFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.amount'), value: 'importe', show: this.isShowImporteFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.status'), value: 'estado', show: this.isShowEstadoFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.reception_method'), value: 'recepcion', show: this.isShowReceptionMethodInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.register_number'), value: 'numero-registro', show: this.isShowNumRegistroFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.currency'), value: 'divisa', show: this.isShowDivisaFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.project'), value: 'servicio', show: this.isShowServicioFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.id_invoice'), value: 'id', show: this.isShowIdDatabaseFacturaInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.paymentMethod'), value: 'paymentMethod', show: this.isShowPaymentMethodInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.clientInvoiceNumber'), value: 'clientInvoiceNumber', show: this.isShowClientInvoiceNumberInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.accountingDate'), value: 'accountingDate', show: this.isShowAccountingDateInReceivedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.paymentDate'), value: 'paymentDate', show: this.isShowPaymentDateInReceivedSearch
          }
        ]
      }

      // Si el usuario sólo tiene un servicio, quitamos el checkbox de servicios
      if (this.optionsFilterService.length < 2) {
        for (let index = 0; index < this.columns.length; index++) {
          const element = this.columns[index]
          if (element.value === 'servicio') {
            this.columns.splice(index, 1)
          }
        }
      }
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
